/** Standard custom-dimension keys (string values only for App Insights). */
export const TelemetryProp = {
  surface: "surface",
  route: "route",
  entity: "entity",
  title: "title",
  error: "error",
  filterType: "filter_type",
  value: "value",
  organisationId: "organisationId",

  invoiceCount: "invoice_count",
  isReadMode: "is_read_mode",
  hasPreviousDraft: "has_previous_draft",
  hasOrganisationAttachments: "has_organisation_attachments",
  isNewInvoice: "is_new_invoice",
  skipDays: "skip_days",
  queryLength: "query_length",
  resultCount: "result_count",
  resultType: "result_type",
  isReassign: "is_reassign",
  commentLength: "comment_length",
  mentionCount: "mention_count",
  entryId: "entry_id",
  hubAction: "hub_action",
  toneId: "tone_id",
  fileCount: "file_count",
} as const;

/** Drops null/undefined/empty string values. */
export function toTelemetryProps(record: Record<string, string | undefined | null>): Record<string, string> {
  return Object.fromEntries(Object.entries(record).filter(([, v]) => v != null && v !== "") as [string, string][]);
}
